import styled from "@emotion/styled";
import { theme } from "theme";

export const DataTable = styled.div`
  font-size: 18px;

  .advanced-filters {
    display: flex;
    justify-content: space-between;
    margin-bottom: ${theme.spacing(3)};

    .form-field {
      width: 350px;
    }

    .sort-field-container {
      width: max-content;
    }
  }

  .excel-download-btn {
    margin-bottom: 1rem;
    float: left;
  }

  table {
    width: 100%;
    border-radius: ${theme.shape.borderRadius}px;
    border-spacing: 0;
    border: 1px solid ${theme.palette.grey[300]};

    thead {
      th {
        border-bottom: 2px solid ${theme.palette.grey[500]} !important;
      }
    }

    tr {
      &:first-child {
        th,
        td {
          &:first-child {
            border-top-right-radius: ${theme.shape.borderRadius}px;
          }
          &:last-child {
            border-top-left-radius: ${theme.shape.borderRadius}px;
          }
        }
      }
      &:last-child {
        td {
          &:first-child {
            border-bottom-right-radius: ${theme.shape.borderRadius}px;
          }
          &:last-child {
            border-bottom-left-radius: ${theme.shape.borderRadius}px;
          }
        }
      }

      th,
      td {
        background-color: ${theme.palette.background.paper};
        text-align: right;
        padding: ${theme.spacing(3)};

        border-bottom: 1px solid ${theme.palette.grey[300]};
        border-left: 1px solid ${theme.palette.grey[300]};

        &.empty-state {
          text-align: center;
          font-size: 14px;
          color: ${theme.palette.grey[300]};
        }

        &:first-of-type {
          padding-right: ${theme.spacing(4)};
        }
        &:last-child {
          border-left: 0;
        }
      }

      th {
        font-size: 17px;
        text-align: center;
        padding-right: ${theme.spacing(10)};
        padding-left: ${theme.spacing(10)};
      }

      &:last-child {
        th,
        td {
          border-bottom: 0;
        }
      }
    }

    .list-action-btn {
      width: max-content;
      border: none !important;
    }
  }
`;
